import {
  QuoteInfo as KitQuoteInfo,
  WarningIcon,
} from "lola-framework-ui-test";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../../store/globalState";

export interface QuoteInfoProps {
  label: string;
  amount?: string;
  icon?: JSX.Element;
  currency: string;
  mode?: "info" | "input";
  exchangeRate?: number;
  showQuouteInfoPopup?: () => void;
}

export const QuoteInfo: React.FC<QuoteInfoProps> = ({
  label,
  amount,
  icon,
  currency,
  mode = "info",
  exchangeRate,
  showQuouteInfoPopup = () => {},
}) => {
  const { amountState, setAmountState } = useStore();
  const { t } = useTranslation();

  return (
    <KitQuoteInfo
      label={label}
      amount={amount}
      icon={icon}
      currency={currency}
      mode={mode}
      exchangeRate={exchangeRate}
      showQuouteInfoPopup={showQuouteInfoPopup}
      initialAmount={amountState.amount?.toString() || ""}
      onAmountChange={(nextAmount) => setAmountState({ amount: nextAmount })}
      translations={{
        rateText: t("exchange.rate", {
          from: "{from}",
          rate: "{rate}",
          to: "{to}",
        }),
        estimatedRate: t("transfer.estimated.rate"),
      }}
      WarningIcon={
        <WarningIcon
          size={26}
          className="icon-info"
          onClick={showQuouteInfoPopup}
        />
      }
    />
  );
};
